import styled from "styled-components";
import Colors from "../../constants/Colors";

export const QuestionOption = styled.div<{selected?: boolean, isMobile?: boolean, isDemo?: boolean, isView?: boolean}>`
    border: ${props=>props.selected? 
        (props.isDemo? `2px solid ${Colors.GRAY400} `:`2px solid ${Colors.SPM500}`) : ''};
    border-radius: 8px;
    padding: ${props=>props.isMobile? '1px 35px':'5px 45px'};
    background-color: ${props=>props.selected? 
        (props.isDemo? `${Colors.GRAY300}`:`${Colors.SPM100}`) : (props.isDemo? `${Colors.GRAY200}`:'#F3FAFF')};
    cursor: ${props=>(props.isDemo || props.isView)? 'default':'pointer'};
    color:  ${props=>props.selected? 
        (props.isDemo? `${Colors.GRAY700}`:`${Colors.SPM500}`) : (props.isDemo? `${Colors.GRAY400}`:`#95ACBF`)};
`

export const QuestionOptionContainer = styled.div<{isMobile?: boolean}>`
    display: flex;
    width: ${props=>props.isMobile? '100%':'63%'};
    justify-content: space-between;
    margin: auto;
`

export const QuestionOptionText = styled.p`
    font-size: 20px;
    font-weight: bold;
`
export const QuestionNumberContainer = styled.div`
    display: flex;
    width: 5%;
    margin-right: 5px;
    font-weight: bold;
`
export const QuestionContainer = styled.div<{isMobile?: boolean}>`
    width: 100%;
    display: flex;
    flex-direction: ${props=>props.isMobile? 'column':'row'};
    padding-top: 5px;
    padding-bottom: 10px;
    border-top: 1px solid ${Colors.GRAY200};
    border-bottom: 1px solid ${Colors.GRAY200};
`

export const ScaleContainer = styled.div<{isMobile?: boolean}>`
    display: flex;
    flex-direction: row;
    width: ${props=>props.isMobile? '100%':'61%'};
    margin-left: ${props=>props.isMobile? '':'36.8%'};
    justify-content: space-between;

`
export const ScaleInfoContainer = styled.div`
    text-align: center;
    width: 104px;
    word-break: break-all;
`

export const QuestionBody = styled.div<{isMobile?: boolean}>`
    display: flex;
    font-weight: bold;
    width: ${props=>props.isMobile? '100%':'30%'};
    word-break: break-all;
    margin-right: 5px;
`
export const ScaleInfoText = styled.p`
    font-size: 12px;
    font-weight: bold;
    word-break: normal;
    color: #575757;
`